import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { isDarkMode, toggleTheme } = useTheme();

    return (
        <nav className={`${isDarkMode ? 'bg-grey-900' : 'bg-white'} shadow-lg fixed w-full z-50 transition-colors duration-200`}>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between h-16">
                    <div className="flex">
                        <div className="flex-shrink-0 flex items-center">
                            <Link to="/" className={`text-2xl font-bold ${isDarkMode ? 'text-primary-400' : 'text-primary'}`}>
                                TechCognita
                            </Link>
                        </div>
                        <div className="hidden sm:ml-6 sm:flex sm:space-x-8">
                            <Link
                                to="/"
                                className={`${isDarkMode
                                    ? 'text-grey-300 hover:text-white hover:border-grey-400'
                                    : 'text-grey-500 hover:text-grey-700 hover:border-grey-300'
                                    } border-transparent inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium`}
                            >
                                Home
                            </Link>
                            <Link
                                to="/about"
                                className={`${isDarkMode
                                    ? 'text-grey-300 hover:text-white hover:border-grey-400'
                                    : 'text-grey-500 hover:text-grey-700 hover:border-grey-300'
                                    } border-transparent inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium`}
                            >
                                About
                            </Link>
                            <Link
                                to="/courses"
                                className={`${isDarkMode
                                    ? 'text-grey-300 hover:text-white hover:border-grey-400'
                                    : 'text-grey-500 hover:text-grey-700 hover:border-grey-300'
                                    } border-transparent inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium`}
                            >
                                Courses
                            </Link>
                            <Link
                                to="/services"
                                className={`${isDarkMode
                                    ? 'text-grey-300 hover:text-white hover:border-grey-400'
                                    : 'text-grey-500 hover:text-grey-700 hover:border-grey-300'
                                    } border-transparent inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium`}
                            >
                                Services
                            </Link>
                            <Link
                                to="/projects"
                                className={`${isDarkMode
                                    ? 'text-grey-300 hover:text-white hover:border-grey-400'
                                    : 'text-grey-500 hover:text-grey-700 hover:border-grey-300'
                                    } border-transparent inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium`}
                            >
                                Projects
                            </Link>
                            <a
                                href="https://blog.techcognita.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`${isDarkMode
                                    ? 'text-grey-300 hover:text-white hover:border-grey-400'
                                    : 'text-grey-500 hover:text-grey-700 hover:border-grey-300'
                                    } border-transparent inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium`}
                            >
                                Blog
                            </a>
                            <Link
                                to="/contact"
                                className={`${isDarkMode
                                    ? 'text-grey-300 hover:text-white hover:border-grey-400'
                                    : 'text-grey-500 hover:text-grey-700 hover:border-grey-300'
                                    } border-transparent inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium`}
                            >
                                Contact
                            </Link>
                        </div>
                    </div>
                    <div className="hidden sm:ml-6 sm:flex sm:items-center space-x-4">
                        <button
                            onClick={toggleTheme}
                            className={`p-2 rounded-md ${isDarkMode
                                ? 'text-grey-300 hover:text-white hover:bg-grey-800'
                                : 'text-grey-500 hover:text-grey-700 hover:bg-grey-100'
                                } focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary transition-colors duration-200`}
                        >
                            {isDarkMode ? (
                                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
                                </svg>
                            ) : (
                                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
                                </svg>
                            )}
                        </button>
                        <Link
                            to="/contact"
                            className="bg-primary text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-primary-600 transition duration-150 ease-in-out"
                        >
                            Get Started
                        </Link>
                    </div>
                    <div className="-mr-2 flex items-center sm:hidden">
                        <button
                            onClick={toggleTheme}
                            className={`p-2 rounded-md mr-2 ${isDarkMode
                                ? 'text-grey-300 hover:text-white hover:bg-grey-800'
                                : 'text-grey-500 hover:text-grey-700 hover:bg-grey-100'
                                } focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary transition-colors duration-200`}
                            aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
                        >
                            {isDarkMode ? (
                                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
                                </svg>
                            ) : (
                                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
                                </svg>
                            )}
                        </button>
                        <button
                            onClick={() => setIsOpen(!isOpen)}
                            className={`inline-flex items-center justify-center p-2 rounded-md ${isDarkMode
                                ? 'text-grey-400 hover:text-grey-300 hover:bg-grey-800'
                                : 'text-grey-400 hover:text-grey-500 hover:bg-grey-100'
                                } focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary`}
                        >
                            <span className="sr-only">Open main menu</span>
                            {!isOpen ? (
                                <svg className="block h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                </svg>
                            ) : (
                                <svg className="block h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            )}
                        </button>
                    </div>
                </div>
            </div>

            {/* Mobile menu */}
            {isOpen && (
                <div className={`sm:hidden ${isDarkMode ? 'bg-grey-900' : 'bg-white'}`}>
                    <div className="pt-2 pb-3 space-y-1">
                        <Link
                            to="/"
                            className={`block pl-3 pr-4 py-2 border-l-4 text-base font-medium border-transparent ${isDarkMode
                                ? 'text-grey-300 hover:bg-grey-800 hover:border-grey-400 hover:text-white'
                                : 'text-grey-500 hover:bg-grey-50 hover:border-grey-300 hover:text-grey-700'
                                }`}
                            onClick={() => setIsOpen(false)}
                        >
                            Home
                        </Link>
                        <Link
                            to="/about"
                            className={`block pl-3 pr-4 py-2 border-l-4 text-base font-medium border-transparent ${isDarkMode
                                ? 'text-grey-300 hover:bg-grey-800 hover:border-grey-400 hover:text-white'
                                : 'text-grey-500 hover:bg-grey-50 hover:border-grey-300 hover:text-grey-700'
                                }`}
                            onClick={() => setIsOpen(false)}
                        >
                            About
                        </Link>
                        <Link
                            to="/courses"
                            className={`block pl-3 pr-4 py-2 border-l-4 text-base font-medium border-transparent ${isDarkMode
                                ? 'text-grey-300 hover:bg-grey-800 hover:border-grey-400 hover:text-white'
                                : 'text-grey-500 hover:bg-grey-50 hover:border-grey-300 hover:text-grey-700'
                                }`}
                            onClick={() => setIsOpen(false)}
                        >
                            Courses
                        </Link>
                        <Link
                            to="/services"
                            className={`block pl-3 pr-4 py-2 border-l-4 text-base font-medium border-transparent ${isDarkMode
                                ? 'text-grey-300 hover:bg-grey-800 hover:border-grey-400 hover:text-white'
                                : 'text-grey-500 hover:bg-grey-50 hover:border-grey-300 hover:text-grey-700'
                                }`}
                            onClick={() => setIsOpen(false)}
                        >
                            Services
                        </Link>
                        <Link
                            to="/projects"
                            className={`block pl-3 pr-4 py-2 border-l-4 text-base font-medium border-transparent ${isDarkMode
                                ? 'text-grey-300 hover:bg-grey-800 hover:border-grey-400 hover:text-white'
                                : 'text-grey-500 hover:bg-grey-50 hover:border-grey-300 hover:text-grey-700'
                                }`}
                            onClick={() => setIsOpen(false)}
                        >
                            Projects
                        </Link>
                        <a
                            href="https://blog.techcognita.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`block pl-3 pr-4 py-2 border-l-4 text-base font-medium border-transparent ${isDarkMode
                                ? 'text-grey-300 hover:bg-grey-800 hover:border-grey-400 hover:text-white'
                                : 'text-grey-500 hover:bg-grey-50 hover:border-grey-300 hover:text-grey-700'
                                }`}
                            onClick={() => setIsOpen(false)}
                        >
                            Blog
                        </a>
                        <Link
                            to="/contact"
                            className={`block pl-3 pr-4 py-2 border-l-4 text-base font-medium border-transparent ${isDarkMode
                                ? 'text-grey-300 hover:bg-grey-800 hover:border-grey-400 hover:text-white'
                                : 'text-grey-500 hover:bg-grey-50 hover:border-grey-300 hover:text-grey-700'
                                }`}
                            onClick={() => setIsOpen(false)}
                        >
                            Contact
                        </Link>
                        {/* <button
                            onClick={toggleTheme}
                            className={`w-full text-left pl-3 pr-4 py-2 border-l-4 text-base font-medium border-transparent ${isDarkMode
                                ? 'text-grey-300 hover:bg-grey-800 hover:border-grey-400 hover:text-white'
                                : 'text-grey-500 hover:bg-grey-50 hover:border-grey-300 hover:text-grey-700'
                                }`}
                        >
                            {isDarkMode ? 'Light Mode' : 'Dark Mode'}
                        </button> */}
                        <div className="px-3 py-2">
                            <Link
                                to="/contact"
                                className="block w-full bg-primary text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-primary-600 transition duration-150 ease-in-out text-center"
                                onClick={() => setIsOpen(false)}
                            >
                                Get Started
                            </Link>
                        </div>
                    </div>
                </div>
            )}
        </nav>
    );
};

export default Navbar;